import { Button, CircularProgress } from '@material-ui/core';
import { Error } from '@material-ui/icons';
import React from 'react';
import { ContentPlanStatus } from '../../../ContentPlanPage';

export interface ProcessingIndicatorProps {
  openProgress: () => void;
  status?: ContentPlanStatus;
}

export const ProcessingIndicator: React.FC<ProcessingIndicatorProps> = ({ openProgress, status }) => {
  if (!status || status === 'completed') return null;
  return (
    <Button
      endIcon={status === 'failed' ? <Error color="error" /> : <CircularProgress size={18} />}
      onClick={openProgress}
      color="primary"
    >
      {status === 'failed' ? 'Failed' : 'Processing'}
    </Button>
  );
};

export default ProcessingIndicator;
